import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BookShowcase from '../components/BookShowcase';
import SpeakerSocialLinks from '../components/SpeakerSocialLinks';
import { SPONSOR_FORM_URL } from '../config';
import '../styles/DavidSinclairPage.css';

function DavidSinclairPage() {
  return (
    <>
      <Navbar />
      
      {/* Hero Section */}
      <section className="speaker-hero">
        <video 
          className="speaker-hero-video"
          autoPlay 
          muted 
          loop 
          playsInline
        >
          <source src="/assets/video-hero.webm" type="video/webm" />
        </video>
        <div className="speaker-hero-overlay"></div>
        
        <div className="container">
          <div className="speaker-hero-content">
            <div className="speaker-hero-left">
              <h1 className="speaker-hero-name">
                DAVID<br />SINCLAIR
              </h1>
              <SpeakerSocialLinks speakerId="david-sinclair" className="speaker-hero-socials" linkClassName="speaker-hero-social-icon" />
              {/* <p className="speaker-hero-date">DAY 1 - September 16</p> */}
              {/* <h2 className="speaker-hero-title">Leading through adversities</h2> */}
              <Link to="https://my.brain-event.com" className="btn btn-primary btn-large btn-pulse speaker-hero-btn">
                CUMPĂRĂ UN TICKET
              </Link>
            </div>
            
            <div className="speaker-hero-right">
              <img 
                src="/assets/david-sinclair-hero-image-speaker.webp" 
                alt="David Sinclair" 
                className="speaker-hero-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Who is David Sinclair - New Section */}
      <section className="sinclair-intro">
        <div className="container">
          <div className="sinclair-intro-grid">
            <div className="sinclair-intro-content">
              <div className="sinclair-badge">DAVID A. SINCLAIR</div>
              <h2 className="sinclair-intro-title">Cine este David Sinclair?</h2>
              <p className="sinclair-intro-text">
                David A. Sinclair este unul dintre cei mai cunoscuți cercetători din lume în domeniul longevității. 
              </p>
              <p className="sinclair-intro-text">
                Cartea sa <strong>„Lifespan"</strong> a devenit <strong>bestseller internațional</strong>, iar ideile lui au schimbat modul în care oamenii privesc procesul de îmbătrânire.
              </p>
              <div className="sinclair-highlight-box">
                <p>A fost inclus de <strong>două ori</strong> în lista <strong>TIME Magazine „100 cei mai influenți oameni din lume"</strong></p>
              </div>
            </div>
            <div className="sinclair-intro-image">
              <img 
                src="/david-sinclair-headshot-2024.png" 
                alt="David Sinclair"
                className="sinclair-portrait"
              />
              {/* Floating Stats Cards */}
              <div className="floating-stats-cards">
                <div className="floating-stat-card">
                  <div className="floating-stat-number">180+</div>
                  <div className="floating-stat-label">Lucrări științifice</div>
                </div>
                <div className="floating-stat-card">
                  <div className="floating-stat-number">100K+</div>
                  <div className="floating-stat-label">Cercetări citate</div>
                </div>
                <div className="floating-stat-card">
                  <div className="floating-stat-number">50+</div>
                  <div className="floating-stat-label">Brevete</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* David Sinclair Book Showcase */}
      <BookShowcase
        badge="Bestseller mondial"
        mainTitle="Autorul cărții &quot;Lifespan&quot;"
        description="&quot;Lifespan&quot; este una dintre cele mai populare cărți despre longevitate și sănătate. La Brain Event, vei vedea principiile din carte explicate clar și aplicabil."
        bookImage="/assets/lifespan-book-david-sinclair.webp"
        primaryButtonText="Rezervă bilet"
        primaryButtonLink="https://my.brain-event.com"
        secondaryButtonText="Vezi pachete"
        secondaryButtonLink="https://my.brain-event.com"
        backgroundColor="#F5F1E8"
      />

      {/* What He Will Talk About - Using Benefits Design */}
      <section className="benefits" id="despre-ce-va-vorbi">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Despre ce va vorbi</h2>
            <p className="section-subtitle">Teme centrale din prezentarea lui David Sinclair</p>
          </div>

          <div className="benefits-stories-grid">
            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/imbatrinirea-ca-proces-biologic.png)'}}>
              <div className="story-badge">Concept cheie</div>
              <div className="story-content">
                <h3 className="story-title">Îmbătrânirea ca proces biologic</h3>
                <p className="story-description">De ce îmbătrânirea nu e doar "trecerea timpului", ci un proces biologic influențabil</p>
              </div>
            </div>

            <div className="benefit-story-card benefit-story-featured" style={{backgroundImage: 'url(/assets/ce-se-intampla-la-nivel-celular.png)'}}>
              <div className="story-badge story-badge-featured">Mecanism</div>
              <div className="story-content">
                <h3 className="story-title">Ce se întâmplă la nivel celular</h3>
                <p className="story-description">Mecanismele care se declanșează în corp la nivel celular când îmbătrânim</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/mecanisme-naturale-de-reparare.png)'}}>
              <div className="story-badge">Soluții naturale</div>
              <div className="story-content">
                <h3 className="story-title">Mecanisme naturale de reparare</h3>
                <p className="story-description">Cum pot fi susținute mecanismele naturale de reparare ale organismului</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/longevitate-vs-calitatea-vietii.png)'}}>
              <div className="story-badge">Perspectivă</div>
              <div className="story-content">
                <h3 className="story-title">Longevitate vs calitate a vieții</h3>
                <p className="story-description">Diferența dintre a trăi mai mult și a trăi mai bine</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/idei-practice-si-actionabile.png)'}}>
              <div className="story-badge">Aplicații</div>
              <div className="story-content">
                <h3 className="story-title">Idei practice și acționabile</h3>
                <p className="story-description">Idei practice, conectate la prevenție și sănătate pe termen lung</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large">Cumpără un ticket</a>
          </div>
        </div>
      </section>

      {/* How It Helps You */}
      <section className="sinclair-benefits-you">
        <div className="container">
          <div className="section-header-centered">
            <h2 className="section-title">Cu ce te ajută pe tine</h2>
            <p className="section-subtitle">Beneficii concrete din prezentarea lui David Sinclair</p>
          </div>

          <div className="benefits-you-list">
            <div className="benefit-you-item">
              <div className="benefit-you-number">01</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Înțelegere profundă a îmbătrânirii</h3>
                <p className="benefit-you-description">Înțelegi mai clar <strong>de ce corpul îmbătrânește</strong> și ce contează cu adevărat pentru sănătate</p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">02</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Prioritizare corectă a obiceiurilor</h3>
                <p className="benefit-you-description">Îți <strong>prioritizezi mai bine obiceiurile</strong> care au impact pe termen lung</p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">03</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Decizii mai bune pentru sănătate</h3>
                <p className="benefit-you-description">Iei <strong>decizii mai bune</strong> pentru energie, claritate și calitatea vieții</p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">04</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Separare trend-uri de știință</h3>
                <p className="benefit-you-description">Separi <strong>trendurile de lucrurile cu bază solidă</strong> în sănătate</p>
              </div>
            </div>

            <div className="benefit-you-item featured">
              <div className="benefit-you-number">05</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Direcție clară pentru longevitate</h3>
                <p className="benefit-you-description">Pleci cu o <strong>direcție clară</strong>: cum să-ți construiești un stil de viață care susține <strong>longevitatea reală</strong></p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large btn-pulse">Rezervă-ți locul acum</a>
            <p className="cta-subtitle">Locuri limitate • Brain Event 2026</p>
          </div>
        </div>
      </section>

      {/* Discoveries Section - Icon Grid */}
      <section className="sinclair-discoveries">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Ce a descoperit</h2>
            <p className="section-subtitle">Contribuții care au marcat domeniul științei moderne</p>
          </div>

          <div className="discoveries-grid">
            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2" opacity="0.3"/>
                  <circle cx="24" cy="24" r="14" stroke="currentColor" strokeWidth="2" opacity="0.5"/>
                  <circle cx="24" cy="24" r="8" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="24" cy="24" r="3" fill="currentColor"/>
                  <path d="M24 4 L24 10 M24 38 L24 44 M4 24 L10 24 M38 24 L44 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="discovery-title">Mecanismele îmbătrânirii celulare</h3>
              <p className="discovery-description">A dezvăluit cum și de ce celulele îmbătrânesc la nivel molecular</p>
            </div>

            <div className="discovery-card featured">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 8 L32 20 L28 20 L28 28 L36 28 L36 32 L28 32 L28 40 L20 40 L20 32 L12 32 L12 28 L20 28 L20 20 L16 20 L24 8Z" fill="currentColor" opacity="0.3"/>
                  <circle cx="24" cy="24" r="4" fill="currentColor"/>
                  <circle cx="34" cy="18" r="3" fill="currentColor"/>
                  <circle cx="14" cy="18" r="3" fill="currentColor"/>
                  <circle cx="34" cy="34" r="3" fill="currentColor"/>
                  <circle cx="14" cy="34" r="3" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="discovery-title">Rolul moleculei NAD⁺</h3>
              <p className="discovery-description">A demonstrat importanța NAD⁺ în repararea celulelor și producerea energiei</p>
            </div>

            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 24 Q 16 12, 24 24 T 40 24" stroke="currentColor" strokeWidth="2.5" fill="none"/>
                  <path d="M10 28 Q 18 16, 26 28 T 42 28" stroke="currentColor" strokeWidth="2.5" fill="none" opacity="0.5"/>
                  <circle cx="24" cy="24" r="3" fill="currentColor"/>
                  <circle cx="12" cy="20" r="2" fill="currentColor"/>
                  <circle cx="36" cy="20" r="2" fill="currentColor"/>
                  <circle cx="18" cy="28" r="2" fill="currentColor" opacity="0.5"/>
                  <circle cx="30" cy="28" r="2" fill="currentColor" opacity="0.5"/>
                </svg>
              </div>
              <h3 className="discovery-title">Genele SIRTUIN</h3>
              <p className="discovery-description">A identificat genele care controlează longevitatea și sănătatea celulară</p>
            </div>

            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 8 C24 8, 12 16, 12 26 C12 34, 18 40, 24 40" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
                  <path d="M24 8 C24 8, 36 16, 36 26 C36 34, 30 40, 24 40" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
                  <path d="M18 22 L30 22 M16 28 L32 28 M18 34 L30 34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
                  <circle cx="24" cy="12" r="3" fill="currentColor"/>
                  <path d="M20 38 L28 10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="discovery-title">Teoria inversării îmbătrânirii</h3>
              <p className="discovery-description">Îmbătrânirea poate fi încetinită sau chiar inversată prin intervenții precise</p>
            </div>
          </div>

          <div className="discovery-breakthrough">
            <div className="breakthrough-year">2020</div>
            <div className="breakthrough-content">
              <h3 className="breakthrough-title">Descoperire revoluționară</h3>
              <p className="breakthrough-text">
                Echipa lui de la <strong>Harvard</strong> a reușit să <strong>redea vederea unor animale prin reprogramare celulară</strong> — 
                o descoperire care a atras atenția comunității științifice din întreaga lume.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Public Presence - Media & Podcast - 2 Column Layout */}
      <section className="sinclair-media-new">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Prezență publică</h2>
            <p className="section-subtitle">Știința explicată simplu și accesibil</p>
          </div>

          <div className="media-two-column-grid">
            {/* Card 1: Publicații */}
            <div className="media-two-column-card">
              <div className="media-two-column-content">
                <div className="media-badge-small">Media</div>
                <h3 className="media-two-column-title">Prezentat în top publicații</h3>
                <p className="media-two-column-description">
                  David Sinclair apare constant în cele mai prestigioase publicații internaționale, 
                  de la <strong>New York Times</strong> la <strong>Wall Street Journal</strong>, 
                  <strong>Fortune</strong> și <strong>Newsweek</strong>, unde explică descoperirile sale 
                  despre longevitate și sănătate.
                </p>
                <div className="media-logos-list">
                  <span className="media-outlet-tag">New York Times</span>
                  <span className="media-outlet-tag">Wall Street Journal</span>
                  <span className="media-outlet-tag">Fortune</span>
                  <span className="media-outlet-tag">Newsweek</span>
                </div>
              </div>
              <div className="media-two-column-image">
                <img src="/assets/publicatii.png" alt="David Sinclair în publicații" />
              </div>
            </div>

            {/* Card 2: Podcast Featured */}
            <div className="media-two-column-card featured">
              <div className="media-two-column-image">
                <img src="/assets/lifespan-podcast.png" alt="Lifespan Podcast" />
              </div>
              <div className="media-two-column-content">
                <div className="media-badge-featured">Top Podcast</div>
                <h3 className="media-two-column-title">Podcastul „Lifespan"</h3>
                <p className="media-two-column-description">
                  Unul dintre cele mai ascultate podcasturi din lume în categoria <strong>sănătate</strong>, 
                  unde David explică cercetările într-un mod clar și aplicabil. Milioane de oameni ascultă 
                  săptămânal pentru a învăța despre longevitate, anti-aging și optimizare.
                </p>
                <div className="media-stats">
                  <div className="media-stat-item">
                    <span className="media-stat-number">Top 50</span>
                    <span className="media-stat-label">Health Podcasts</span>
                  </div>
                  <div className="media-stat-item">
                    <span className="media-stat-number">Milioane</span>
                    <span className="media-stat-label">De ascultători</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3: Conferințe */}
            <div className="media-two-column-card">
              <div className="media-two-column-content">
                <div className="media-badge-small">Speaker</div>
                <h3 className="media-two-column-title">Invitat constant la conferințe internaționale</h3>
                <p className="media-two-column-description">
                  Speaker de top la evenimente internaționale de prestigiu, unde transformă 
                  <strong> știința complexă în insight-uri acționabile</strong>. De la TED Talks 
                  la conferințe medicale de nivel mondial, David aduce cercetarea la viață 
                  pentru audiențe diverse.
                </p>
              </div>
              <div className="media-two-column-image">
                <img src="/assets/events-david-sinclair.jpg" alt="David Sinclair la conferințe" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials" id="testimoniale">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Ce spun participanții</h2>
            <p className="section-subtitle">Feedback autentic de la ediția anterioară</p>
          </div>

          {/* Stats First - Impact Numbers */}
          <div className="testimonial-stats-hero">
            <div className="stat-hero-item">
              <div className="stat-hero-number">1000+</div>
              <div className="stat-hero-label">Participanți</div>
              <div className="stat-hero-sublabel">ediția trecută</div>
            </div>
            <div className="stat-hero-divider"></div>
            <div className="stat-hero-item stat-hero-featured">
              <div className="stat-hero-number">10/10</div>
              <div className="stat-hero-label">Rating mediu</div>
              <div className="stat-hero-sublabel">satisfacție maximă</div>
            </div>
            <div className="stat-hero-divider"></div>
            <div className="stat-hero-item">
              <div className="stat-hero-number">95%</div>
              <div className="stat-hero-label">Recomandare</div>
              <div className="stat-hero-sublabel">ar participa din nou</div>
            </div>
          </div>

          {/* Testimonials Grid */}
          <div className="testimonials-grid-modern">
            {/* Testimonial 1 - Featured Large */}
            <div className="testimonial-card-modern featured-large">
              <div className="testimonial-quote-icon">"</div>
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Am plecat cu un plan concret pentru somn și am văzut rezultate în doar 5 zile. Claritate mentală pe care nu am mai simțit-o de ani. Protocoalele sunt simple dar puternice."</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>AM</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Ana Maria</strong>
                  <span className="author-role-modern">Antreprenor, 34 ani</span>
                  <span className="author-result">✓ Focus +40% în 7 zile</span>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="testimonial-card-modern">
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Ca psiholog, am găsit protocoale practice pe care le-am integrat imediat cu clienții mei. Schimbarea a fost vizibilă în primele 2 săptămâni."</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>RP</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Radu Popa</strong>
                  <span className="author-role-modern">Psiholog clinician</span>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="testimonial-card-modern">
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Informații dense dar accesibile. Am ieșit cu instrumente măsurabile și o comunitate de oameni pasionați de aceleași lucruri."</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>MC</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Maria Cristea</strong>
                  <span className="author-role-modern">Biohacker & Coach</span>
                </div>
              </div>
            </div>

            {/* Testimonial 4 */}
            <div className="testimonial-card-modern">
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Mi-am rezolvat problemele de somn după 10 ani de încercări. Acum dorm 7h/noapte și mă trezesc energizat. Schimbător de viață!"</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>DI</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Dan Ionescu</strong>
                  <span className="author-role-modern">Developer, 29 ani</span>
                </div>
              </div>
            </div>

            {/* Testimonial 5 - Video Style */}
            <div className="testimonial-card-modern video-style">
              <div className="video-badge">🎥 Recenzie Video</div>
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Cel mai practic eveniment la care am participat. Zero fluff, doar acțiuni concrete. Workbook-ul e aur curat!"</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>SI</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Simona Ilie</strong>
                  <span className="author-role-modern">Manager HR</span>
                </div>
              </div>
            </div>

            {/* Testimonial 6 */}
            <div className="testimonial-card-modern">
              <div className="testimonial-rating">
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
                <span className="star-filled">★</span>
              </div>
              <p className="testimonial-text-modern">"Am venit sceptic, am plecat convins. Informațiile sunt bazate pe știință, nu pe hype. Super valoros pentru echipa mea."</p>
              <div className="testimonial-author-modern">
                <div className="author-avatar-modern">
                  <span>AL</span>
                </div>
                <div className="author-details">
                  <strong className="author-name-modern">Alex Luca</strong>
                  <span className="author-role-modern">CEO Startup</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Speakers Section - Same Style as "Ce obții la eveniment" */}
      <section className="benefits" id="speakeri">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Alți Speakeri de la Brain Event 2026</h2>
            <p className="section-subtitle">Experți de top din domeniul neuroștiinței și optimizării cognitive</p>
          </div>

          <div className="benefits-stories-grid">
            {/* Diana Palotas */}
            <Link to="/diana-palotas" className="benefit-story-card" style={{backgroundImage: 'url(/assets/Diana-Palotas-card.webp)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Diana Palotas</h3>
                <p className="story-description">CEO Neuros</p>
                {/* <SpeakerSocialLinks speakerId="diana-palotas" className="benefit-story-socials" linkClassName="benefit-story-social-icon" stopPropagation /> */}
              </div>
            </Link>

            {/* Dr. Daniel Amen */}
            <Link to="/daniel-amen" className="benefit-story-card" style={{backgroundImage: 'url(/assets/amen-speaker.webp)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Dr. Daniel Amen</h3>
                <p className="story-description">Medic în Sănătatea Creierului • Prezență Online</p>
                {/* <SpeakerSocialLinks speakerId="daniel-amen" className="benefit-story-socials" linkClassName="benefit-story-social-icon" stopPropagation /> */}
              </div>
            </Link>

            {/* Niculina Gheorghiță */}
            <Link to="/niculina-gheorghita" className="benefit-story-card" style={{backgroundImage: 'url(/assets/niculina-psiholog.webp)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Niculina Gheorghiță</h3>
                <p className="story-description">Psiholog • Autor • Trainer</p>
              </div>
            </Link>

            {/* Matthew Walker - Featured */}
            <Link to="/matthew-walker" className="benefit-story-card benefit-story-featured" style={{backgroundImage: 'url(/assets/matthew-walker-speaker.webp)'}}>
              <div className="story-badge story-badge-featured">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Matthew Walker</h3>
                <p className="story-description">Expert în Somnologie • Autor Bestseller</p>
              </div>
            </Link>

            {/* Specialist Neurofiziologie */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Specialist Neurofiziologie</h3>
                <p className="story-description">A definit standardele moderne ale neruofiziologiei</p>
              </div>
            </div>

            {/* Expert Neuroreglare */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Expert Neuroreglare</h3>
                <p className="story-description">A optimizat recuperarea sistemului nervos</p>
              </div>
            </div>

            {/* Psiholog si Formator */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Psiholog si Formator</h3>
                <p className="story-description">Trei Decenii in practica psihologica</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large">Cumpara un ticket</a>
          </div>
        </div>
      </section>

      {/* Contact / Sponsor form — now on dedicated sponsorship app */}
      <section className="speaker-contact">
        <div className="container">
          <div className="speaker-contact-header">
            <h2 className="speaker-contact-title">Ai întrebări despre David Sinclair sau Brain Event?</h2>
            <p className="speaker-contact-subtitle">
              Completează formularul de sponsorizare și echipa noastră te va contacta în cel mai scurt timp.
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <a href={SPONSOR_FORM_URL} className="btn btn-primary btn-large">Aplică pentru Sponsorizare</a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default DavidSinclairPage;

